var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPanelUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44172e-08 10.0007C-0.000666592 4.48867 4.478 0.00667406 9.99333 7.39895e-06C15.5113 -0.00665926 20.0087 4.49267 20 10.01C19.9907 15.5253 15.5053 20.0047 9.99533 20C4.482 19.9953 0.000666741 15.512 7.44172e-08 10.0007ZM16.4293 15.7687C18.294 13.8513 19.366 10.4033 18.1467 7.04334C16.8907 3.58401 13.514 1.20401 9.636 1.33801C6.07133 1.46067 2.786 3.95801 1.71933 7.43334C0.702666 10.746 1.84133 14.022 3.57333 15.7633C5.04866 13.3667 7.166 12.012 10.0047 12.0127C12.8413 12.014 14.9573 13.37 16.4293 15.7687ZM15.398 16.7573C14.7353 15.1953 12.8193 13.3493 10.0347 13.3333C7.25933 13.3173 5.29466 15.1353 4.602 16.7547C7.624 19.282 12.3327 19.3147 15.398 16.7573Z",
    fill: "#32976B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 7.33226C6.66735 5.48893 8.16069 4.00027 10.006 4.00293C11.85 4.0056 13.3373 5.49893 13.3327 7.34426C13.3287 9.1716 11.8327 10.6656 10.0047 10.6689C8.16869 10.6723 6.66602 9.17026 6.66669 7.33226ZM11.9947 7.33026C11.9927 6.22827 11.1114 5.34227 10.0087 5.33293C8.90802 5.3236 8.00469 6.22693 8.00535 7.3356C8.00602 8.4476 8.90002 9.33426 10.014 9.32893C11.1147 9.32293 11.9967 8.43293 11.9947 7.33026Z",
    fill: "#32976B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPanelUsers);
export default __webpack_public_path__ + "static/media/admin_panel_users.28be8af92bf8f4c629ad7b8694b463af.svg";
export { ForwardRef as ReactComponent };